import { render } from "./TargetsWard.vue?vue&type=template&id=4977d1e0&scoped=true"
import script from "./TargetsWard.vue?vue&type=script&lang=js"
export * from "./TargetsWard.vue?vue&type=script&lang=js"

import "./TargetsWard.vue?vue&type=style&index=0&id=4977d1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4977d1e0"]])

export default __exports__